import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.initialThemeCheck()
  }

  get userTheme() {
    return localStorage.getItem('theme')
  }

  get systemTheme() {
    return window.matchMedia('(prefers-color0scheme: dark)').matches
  }

  initialThemeCheck() {
    if (this.userTheme === 'dark' || (!this.userTheme && this.systemTheme)) {
      document.documentElement.classList.add('dark')
      window.dispatchEvent(new Event('scroll'))
    }
  }

  switchTheme(event) {
    event.preventDefault()

    if (document.documentElement.classList.contains('dark')) {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('theme', 'light')
      window.dispatchEvent(new Event('scroll'))
      return
    }

    document.documentElement.classList.add('dark')
    localStorage.setItem('theme', 'dark')
    window.dispatchEvent(new Event('scroll'))
  }
}
